import * as types from '@/store/mutation-types'
import { setSessionStorage, clearSessionStorage } from '@/utils'
import {
  SESSION_STORAGE_TOKEN,
  SESSION_STORAGE_OPEN_ID,
  SESSION_STORAGE_USER_INFO,
  SESSION_STORAGE_BIND,
} from '@/config'

// 设置token
export const setToken = ({ commit }, token) => {
  setSessionStorage(SESSION_STORAGE_TOKEN, token)
  commit(types.SET_TOKEN, token)
}

// 设置openId
export const setOpenId = ({ commit }, openId) => {
  setSessionStorage(SESSION_STORAGE_OPEN_ID, openId)
  commit(types.SET_OPEN_ID, openId)
}

// 设置是否绑定微信帐号
export const setBind = ({ commit }, bind) => {
  setSessionStorage(SESSION_STORAGE_BIND, bind)
  commit(types.SET_BIND, bind)
}

// 设置用户信息
export const setUserInfo = ({ commit }, userInfo) => {
  setSessionStorage(SESSION_STORAGE_USER_INFO, userInfo)
  commit(types.SET_USER_INFO, userInfo)
}

// 设置登出
export const setLogout = ({ commit }) => {
  clearSessionStorage(SESSION_STORAGE_TOKEN)
  clearSessionStorage(SESSION_STORAGE_BIND)
  clearSessionStorage(SESSION_STORAGE_USER_INFO)
  commit(types.SET_LOGOUT)
}
